import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchChefList, fetchKitchensList, getKitchenStatus } from "../../store/chefActions";

import ChefCardWrapper from "./ChefCardWrapper";
import ChefCardsSlider from "./ChefCardsSlider";
import { propTypes } from "react-bootstrap/esm/Image";
// import "./sliderstyles.css";

const ChefCards = (props) => {
  const dispatch = useDispatch();
  const chefList = useSelector((state) => state.chef.chefList);
  const chefListLoaded = useSelector((state) => state.chef.chefListLoaded);

  useEffect(() => {
    // dispatch(fetchChefList());
    // dispatch(fetchKitchensList());
    // dispatch(getKitchenStatus());
  }, [dispatch]);
  //TODO
  return <></>

  return (
    <div style={{display:"none"}}>
    <ChefCardWrapper>
      <ChefCardsSlider
        chefList={chefList}
        chefListLoaded={chefListLoaded}
        autoSwipe={props.autoSwipe}
      />
    </ChefCardWrapper>
    </div>
  );
};

export default ChefCards;
